export interface WorkerMessage {
  id: string;
  dbName?: string;
  type: keyof typeof ActionType;
  params?: any;
}

export interface WorkerResponse {
  id: string;
  success: boolean;
  data?: any;
  error?: any;
}

export enum ActionType {
  initCrypto = 'initCrypto',
  createGroupWithId = 'createGroupWithId',
  getKeyPacakge = 'getKeyPacakge',
  getGroupInfo = 'getGroupInfo',
  addMembers = 'addMembers',
  joinGroup = 'joinGroup',
  leaveGroup = 'leaveGroup',
  removeMembers = 'removeMembers',
  contains = 'contains',
  joinByExternalCommit = 'joinByExternalCommit',
  applyCommit = 'applyCommit',
  epoch = 'epoch',
  loadGroups = 'loadGroups',
  deleteGroup = 'deleteGroup',
  selfUpdate = 'selfUpdate',
  encryptMessage = 'encryptMessage',
  decryptMessage = 'decryptMessage',
}
